import { Organization, OrganizationApiResponse } from '@core/model/organization/organization.model';
import { Doctor, DoctorApiResponse } from '@core/model/doctor/doctor.model';

export interface UserApiResponse {
  createdAt: string;
  dateOfBirth: string;
  deletedAt: string;
  doctor: DoctorApiResponse;
  email: string;
  failedLoginAttempts: string;
  firstName: string;
  gender: string;
  id: number;
  lastLogged: string;
  lastName: string;
  organizations: Array<OrganizationApiResponse>;
  phone: string;
  platformType: string;
  recoveryCreatedAt: string;
  status: string;
  supplier: string;
  twoFa: boolean | string;
  twoFaMethod: string;
  emailSet: string;
  isSso: string;
}

export interface UserModel {
  createdAt: Date;
  dateOfBirth: Date;
  deletedAt: Date;
  doctor: Doctor | Partial<Doctor>;
  email: string;
  failedLoginAttempts: string;
  firstName: string;
  gender: string;
  id: number;
  lastLogged: Date;
  lastName: string;
  organizations: Array<Organization>;
  phone: string;
  platformType: string;
  recoveryCreatedAt: Date;
  status: string;
  supplier: string;
  speciality?: string;
  specialityGroup?: string;
  twoFa: boolean | string;
  twoFaMethod: string;
  emailSet: string;
  isSso: string;
  salutation?: string;
  title?: string;
}

export interface ISentByUser {
  sentByBsnr: string;
  sentBy: string;
}

export class User implements UserModel {
  createdAt = new Date();
  dateOfBirth = new Date();
  deletedAt = new Date();
  doctor: Doctor | Partial<Doctor> = new Doctor();
  email = '';
  failedLoginAttempts = '';
  firstName = '';
  gender = '';
  id = -1;
  speciality = '';
  specialityGroup = '';
  lastLogged = new Date();
  lastName = '';
  organizations = new Array<Organization>();
  phone = '';
  platformType = '';
  recoveryCreatedAt = new Date();
  status = '';
  supplier = '';
  twoFa: boolean | string = '';
  twoFaMethod = '';
  emailSet = '';
  isSso = '';
  salutation ?= '';
  title ?= '';

  constructor(dto?: UserModel) {
    if (!dto) {
      return;
    }
    this.createdAt = new Date(dto.createdAt);
    this.dateOfBirth = new Date(dto.dateOfBirth);
    this.deletedAt = new Date(dto.deletedAt);
    this.doctor = dto.doctor;
    this.email = dto.email;
    this.failedLoginAttempts = dto.failedLoginAttempts;
    this.firstName = dto.firstName;
    this.gender = dto.gender;
    this.id = dto.id;
    this.lastLogged = dto.lastLogged;
    this.lastName = dto.lastName;
    this.organizations = dto.organizations;
    this.phone = dto.phone;
    this.platformType = dto.platformType;
    this.recoveryCreatedAt = dto.recoveryCreatedAt;
    this.status = dto.status;
    this.supplier = dto.supplier;
    this.twoFa = dto.twoFa;
    this.twoFaMethod = dto.twoFaMethod;
    this.emailSet = dto.emailSet
    this.isSso = dto.isSso;
    this.salutation = dto.salutation;
    this.title = dto.title;
  }

  static parseDTO(dto: UserApiResponse): User {
    const organizationArray: Array<Organization> = [];
    dto.organizations.map((organization: OrganizationApiResponse): void=>{
      organizationArray.push(Organization.parseDTO(organization));
    })
    return new User({
      createdAt: new Date(dto.createdAt),
      dateOfBirth: new Date(dto.dateOfBirth),
      deletedAt: new Date(dto.deletedAt),
      doctor: dto.doctor ? Doctor.parseDTO(dto.doctor) : new Doctor(),
      email: dto.email,
      failedLoginAttempts: dto.failedLoginAttempts,
      firstName: dto.firstName,
      gender: dto.gender,
      id: dto.id,
      lastLogged: new Date(dto.lastLogged),
      lastName: dto.lastName,
      organizations: organizationArray,
      phone: dto.phone,
      platformType: dto.platformType,
      recoveryCreatedAt: new Date(dto.recoveryCreatedAt),
      status: dto.status,
      supplier: dto.supplier,
      twoFa: dto.twoFa,
      twoFaMethod: dto.twoFaMethod,
      emailSet: dto.emailSet,
      isSso: dto.isSso
    });
  }
}

export class SentByUser {
  sentByBsnr = '';
  sentBy = '';

  constructor(dto?: ISentByUser) {
    if (!dto) {
      return;
    }

    this.sentByBsnr = dto.sentByBsnr;
    this.sentBy = dto.sentBy;
  }
}
